import 'crypto-js/enc-utf8'
import 'crypto-js/tripledes'
import 'crypto-js/sha1'
import * as CryptoJS from 'crypto-js/core'
import jsrsasign from 'jsrsasign'
import { isJSONStr, isArray, isObject } from '@/utils/validate'

const key = '1234123412ABCDEF'  //十六位十六进制数作为密钥

const reaKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI05e8RfyEnLW/Un629lVJoVHntIanEAETot5nRcLmPJpXbC5lf5UgvVrDPPmoTxc567Hg9qq3AyAqWrSyqI6MECAwEAAQ=='

/**
 * @Author      gx12358
 * @DateTime    2022/11/7
 * @lastTime    2022/11/7
 * @description 项目rsa加密
 */
export function rsaSignStr(str: string) {
  const publicKey = `-----BEGIN PUBLIC KEY-----${reaKey}-----END PUBLIC KEY-----`
  const pub = jsrsasign.KEYUTIL.getKey(publicKey)
  const enc = jsrsasign.KJUR.crypto.Cipher.encrypt(str, pub)
  return jsrsasign.hextob64(enc)
}

//加密方法
export function Encrypt(word) {
  let str: string | object = word
  if (isObject(word) || isArray(word)) {
    str = JSON.stringify(word)
  }
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const ivHex = CryptoJS.enc.Utf8.parse(key)
  const encrypted = CryptoJS.DES.encrypt(str, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

//解密方法
export function Decrypt(word) {
  const keyHex = CryptoJS.enc.Utf8.parse(key)
  const ivHex = CryptoJS.enc.Utf8.parse(key)
  const decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Base64.parse(word)
  }, keyHex, {
    iv: ivHex,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  const decryptedStr = decrypted.toString(CryptoJS.enc.Utf8)
  return isJSONStr(decryptedStr.toString()) ? JSON.parse(decryptedStr.toString()) : decryptedStr.toString()
}
